import type { FC } from "react";

import { type BoxProps, HtImage } from "@hightouch/htui";

import { usePartner } from "./context";

export const PartnerLogo: FC<Readonly<{ size?: BoxProps["height"] }>> = ({
  size = "24px",
}) => {
  const { brand } = usePartner();

  if (brand) {
    return (
      <HtImage src={brand.logo} alt={brand.name} width="auto" height={size} />
    );
  }

  return null;
};
